// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  width: 350px;
  max-height: 500px;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Arial, sans-serif;
  background-color: #f5f5f5;
}

/* Chat flottant */
.floating-chat {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
.chat-toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  background-color: #fff; /* ou transparent si tu veux l'image seule */
  border-radius: 50%;
  width: 60px;  /* adapte à ton image */
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  padding: 4px;
}
/* Texte d'attention à côté du bouton flottant */
.chat-toggle-button-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px; /* espace entre avatar et texte */
  z-index: 10000;
  cursor: pointer;
}

.chat-bot-attention {
  background-color: #4aae9b;
  color: #fff;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  max-width: 200px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  animation: float-text 1.5s ease-in-out infinite;
}
/* Bulle attention du bot sur le bouton flottant */
.ai-attention {
  justify-content: flex-start; /* aligné à gauche du bouton */
  align-items: center;
  margin-right: 32px; /* espace entre la bulle et le bouton */
  animation: float-text 1.5s ease-in-out infinite;
}

.ai-attention .message-text {
  background-color: #4aae9b;
  color: #fff;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 14px;
  max-width: 200px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
}

@keyframes float-text {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}
/* Petite animation pour attirer l'œil */
@keyframes float-text {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}
.chat-toggle-button img.chat-toggle-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;  /* cercle parfait */
}
.chat-toggle-button {
  animation: float 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
/* Header */
.chat-header {
  background-color: #4aae9b;
  color: #fff;
  padding: 10px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* Avatar bot dans le header */
.chat-header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
  display: inline-block;
}
.chat-close-button {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

/* Zone messages */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* Ligne message */
.chat-message {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  align-items: flex-end;
}

/* USER -> gauche */
.chat-message.user {
  justify-content: flex-start;
}

/* AI -> droite */
.chat-message.ai {
  justify-content: flex-end;
}

/* Avatar */
.avatar {
  width: 32px;
  height: 32px;
  margin: 0 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  font-weight: bold;
  font-size: 14px;
  color: #4aae9b;
}

.avatar img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

/* Bulle message */
.message-text {
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  max-width: 75%;
}

.chat-message.user .message-text {
  background-color: #e7f6ff;
  color: #000;
}

.chat-message.ai .message-text {
  background-color: #4aae9b;
  color: white;
}

/* Input */
.chat-input {
  display: flex;
  border-top: 1px solid #ccc;
}

.chat-input input {
  flex: 1 1;
  padding: 10px;
  border: none;
  outline: none;
}

.chat-input button {
  padding: 0 20px;
  border: none;
  background-color: #4aae9b;
  color: #fff;
  cursor: pointer;
}

.chat-input button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 500px) {
  .chat-container {
    width: 90%;
    max-height: 400px;
  }
}

/* AI typing animation */
.ai-typing {
  display: flex;
  gap: 4px;
}

.ai-typing span {
  width: 6px;
  height: 6px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1s infinite;
}

.ai-typing span:nth-child(1) { animation-delay: 0s; }
.ai-typing span:nth-child(2) { animation-delay: 0.2s; }
.ai-typing span:nth-child(3) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatAI.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,sBAAsB,EAAE,4CAA4C;EACpE,kBAAkB;EAClB,WAAW,GAAG,uBAAuB;EACrC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;AACA,gDAAgD;AAChD;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,iCAAiC;EAC3C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,+CAA+C;AACjD;AACA,kDAAkD;AAClD;EACE,2BAA2B,EAAE,8BAA8B;EAC3D,mBAAmB;EACnB,kBAAkB,EAAE,uCAAuC;EAC3D,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;AACA,wCAAwC;AACxC;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,GAAG,mBAAmB;AAC1C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;AACA,WAAW;AACX;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;;AAEtD;EACE,gBAAgB,mBAAmB,EAAE;EACrC,MAAM,mBAAmB,EAAE;AAC7B","sourcesContent":[".chat-container {\n  width: 350px;\n  max-height: 500px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: Arial, sans-serif;\n  background-color: #f5f5f5;\n}\n\n/* Chat flottant */\n.floating-chat {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n}\n.chat-toggle-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 10000;\n  background-color: #fff; /* ou transparent si tu veux l'image seule */\n  border-radius: 50%;\n  width: 60px;  /* adapte à ton image */\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\n  padding: 4px;\n}\n/* Texte d'attention à côté du bouton flottant */\n.chat-toggle-button-wrapper {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px; /* espace entre avatar et texte */\n  z-index: 10000;\n  cursor: pointer;\n}\n\n.chat-bot-attention {\n  background-color: #4aae9b;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  max-width: 200px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n  animation: float-text 1.5s ease-in-out infinite;\n}\n/* Bulle attention du bot sur le bouton flottant */\n.ai-attention {\n  justify-content: flex-start; /* aligné à gauche du bouton */\n  align-items: center;\n  margin-right: 32px; /* espace entre la bulle et le bouton */\n  animation: float-text 1.5s ease-in-out infinite;\n}\n\n.ai-attention .message-text {\n  background-color: #4aae9b;\n  color: #fff;\n  padding: 8px 14px;\n  border-radius: 20px;\n  font-size: 14px;\n  max-width: 200px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.2);\n}\n\n@keyframes float-text {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n/* Petite animation pour attirer l'œil */\n@keyframes float-text {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-3px); }\n}\n.chat-toggle-button img.chat-toggle-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;  /* cercle parfait */\n}\n.chat-toggle-button {\n  animation: float 2s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n/* Header */\n.chat-header {\n  background-color: #4aae9b;\n  color: #fff;\n  padding: 10px;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n/* Avatar bot dans le header */\n.chat-header-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  margin-right: 8px;\n  vertical-align: middle;\n  display: inline-block;\n}\n.chat-close-button {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n/* Zone messages */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Ligne message */\n.chat-message {\n  display: flex;\n  width: 100%;\n  margin-bottom: 10px;\n  align-items: flex-end;\n}\n\n/* USER -> gauche */\n.chat-message.user {\n  justify-content: flex-start;\n}\n\n/* AI -> droite */\n.chat-message.ai {\n  justify-content: flex-end;\n}\n\n/* Avatar */\n.avatar {\n  width: 32px;\n  height: 32px;\n  margin: 0 8px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  font-weight: bold;\n  font-size: 14px;\n  color: #4aae9b;\n}\n\n.avatar img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Bulle message */\n.message-text {\n  padding: 10px 14px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.4;\n  word-break: break-word;\n  max-width: 75%;\n}\n\n.chat-message.user .message-text {\n  background-color: #e7f6ff;\n  color: #000;\n}\n\n.chat-message.ai .message-text {\n  background-color: #4aae9b;\n  color: white;\n}\n\n/* Input */\n.chat-input {\n  display: flex;\n  border-top: 1px solid #ccc;\n}\n\n.chat-input input {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  outline: none;\n}\n\n.chat-input button {\n  padding: 0 20px;\n  border: none;\n  background-color: #4aae9b;\n  color: #fff;\n  cursor: pointer;\n}\n\n.chat-input button:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 500px) {\n  .chat-container {\n    width: 90%;\n    max-height: 400px;\n  }\n}\n\n/* AI typing animation */\n.ai-typing {\n  display: flex;\n  gap: 4px;\n}\n\n.ai-typing span {\n  width: 6px;\n  height: 6px;\n  background-color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1s infinite;\n}\n\n.ai-typing span:nth-child(1) { animation-delay: 0s; }\n.ai-typing span:nth-child(2) { animation-delay: 0.2s; }\n.ai-typing span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes bounce {\n  0%, 80%, 100% { transform: scale(0); }\n  40% { transform: scale(1); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
